import { createSelector } from 'reselect'
import { _selectSortedIds } from './_selectSortedIds'

export const selectFirstMailboxId = createSelector(_selectSortedIds, sorted => {
  const ids = sorted || []
  return ids[0]
})
